<template>
  <div class="PublicityDetail7">
    <h3>金融产品查询平台</h3>
    <img :src="require('../images/ic_publicity_detail7_1.jpg')"/>
  </div>
</template>

<script>
export default {
  name: 'PublicityDetail7'
};
</script>

<style scoped lang="less">
.PublicityDetail7 {
  width: 100%;
  box-sizing: border-box;
  font-size: 18px;
  line-height: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h3 {
    font-weight: bold;
    font-size: 28px;
    line-height: 52px;
    align-self: center;
  }

  div {
    text-align: left;
  }

  img {
    width: 100%;
    margin-top: 30px;
    align-self: center;
  }
}
</style>
